import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class Camera extends Vue {

  @Prop()
  type: string;

  @Prop()
  typeId: any;

  @Prop({ default: 1280 })
  maxWidth: number;

  @Prop({ default: 1280 })
  maxHeight: number;

  @Prop()
  disabled:boolean;

  async takePicture(e: Event) {
    let target = e.target as HTMLInputElement;
    let files: FileList = (target.files as FileList);

    for (const f of files) {
      let image = await this.readImage(f);
      if (image)
        this.$emit('loaded', { type: this.type, typeId: this.typeId, format: 'jpg', buffer: (image as any).split(',')[1] });
    }
  }

  readImage(file): Promise<string> {

    let $this = this;
    var promise = new Promise<string>((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = function (e) {
        // carico l'immagine
        var img = document.createElement("img");
        img.onload = () => {
          if (img.width > img.height && img.width > $this.maxWidth) {
            img.height *= $this.maxWidth / img.width;
            img.width = Math.min(img.width, $this.maxWidth)
          }
          else {
            if (img.width <= img.height && img.height > $this.maxHeight) {
              img.width *= $this.maxHeight / img.height;
              img.height = Math.min(img.height, $this.maxHeight)
            }
          }

          var canvas = document.createElement("canvas") as HTMLCanvasElement;
          var ctx = canvas.getContext("2d");

          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, img.width, img.height);

          resolve(canvas.toDataURL("image/jpg"));
        }
        img.src = e.target.result as string;
      };
      reader.readAsDataURL(file);
    })
    return promise;
  }
}
